/**
 * BUSINESS LOGIC: INTERACTIVE CHAT OVERLAY
 */
import { 
    ShowInteractiveMessage as DLShowInteractiveMessage,
    HideInteractiveMessage as DLHideInteractiveMessage,
    SetInteractiveChatConfig as DLSetInteractiveChatConfig,
    GetQuickReplies as DLGetQuickReplies,
    SaveQuickReply as DLSaveQuickReply,
    DeleteQuickReply as DLDeleteQuickReply
} from './../DL/InteractiveChat' // './../DL/Admin/Overlays/InteractiveChat'; // Ajusta la ruta según tu estructura

export const ShowInteractiveMessage = async (text) => {
    if (!text || text.trim() === '') return { success: false, message: 'El mensaje no puede estar vacío.' };
    return await DLShowInteractiveMessage(text.trim());
};

export const HideInteractiveMessage = async () => {
    return await DLHideInteractiveMessage();
};

export const SetInteractiveChatConfig = async (config) => {
    return await DLSetInteractiveChatConfig(config);
};

export const GetQuickReplies = async () => {
    return await DLGetQuickReplies();
};

export const SaveQuickReply = async (text) => {
    if (!text || text.trim() === '') return { success: false, message: 'El mensaje no puede estar vacío.' };
    return await DLSaveQuickReply(text.trim());
};

export const DeleteQuickReply = async (id) => {
    return await DLDeleteQuickReply(id);
};